module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(this.$store.state.loggedIn) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('va-navibar'), _vm._v(" "), _c('va-slider', {
    attrs: {
      "slideMenuItems": _vm.slideMenuItems
    }
  }), _vm._v(" "), _c('va-content-wrap'), _vm._v(" "), _c('Modal')], 1) : _c('login')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35d3837c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 850
// module chunks = 0